import { memo, useCallback } from 'react';
import { useEvent, useMapContext } from '../../hooks';
/**
 * Добавляет обработчки на изначальную загрузку тайлов
 */
var TilesLoader = function (_a) {
    var onLoad = _a.onLoad;
    var map = useMapContext();
    var loadHandler = useCallback(function (e) {
        if (e.get('readyTileNumber') === e.get('totalTileNumber')) {
            onLoad();
            map.layers.events.remove('tileloadchange', loadHandler);
        }
    }, [map, onLoad]);
    useEvent(map.layers, 'tileloadchange', loadHandler);
    return null;
};
export default memo(TilesLoader);
